export default "__VITE_ASSET__C8Nl2U0O__"